import {Injectable} from '@angular/core';
import {ApiService} from '../api/api.service';
import {ConfigService} from '../config/config.service';
import {StorageService} from '../storage/storage.service';
import {TokenService} from '../token/token.service';
import * as moment from 'moment';
import {UserService} from '../user/user.service';
import {Router} from '@angular/router';

@Injectable()
export class AuthenticationService {

  private client_id: string;
  private client_secret: string;
  private _refreshing: Boolean = false;
  private isLoggedIn: Boolean = false;

  constructor(private api: ApiService,
              private config: ConfigService,
              private token: TokenService,
              private users: UserService,
              private router: Router,
  ) {
    let _api = config.get('api');

    this.client_id = _api['client_id'];
    this.client_secret = _api['client_secret'];
  }


  public isRefreshing() {
    return this._refreshing;
  }


  login(username: string, password: string): Promise<boolean> {
    //this.api.post('oauth/token', {});
    return this.api.post('v1/oauth/token', {
        'username': username,
        'password': password,
        'grant_type': 'password',
        'client_id': this.client_id,
        'client_secret': this.client_secret,
        'scope': ''
      }
    ).then(data => {
      // Save token data
      return this.storeTokenData(data).then(() => {
        this.isLoggedIn = true;
        return true;
      });

    }, error => {
      this.isLoggedIn = false;
      throw error;

      //return error;
    });
  }

  logout() {
    const vm = this;
    this.isLoggedIn = false;
    return this.token.clear().then(() => {
      vm.router.navigate(['/auth/login']);
      window.location.reload();
      return;
    });
  }

  refresh(refresh_token: string) {
    let vm = this;
    if (this._refreshing) {
      return new Promise(function (resolve, reject) {
        (
          function waitForRefresh() {
            if (!vm._refreshing) {
              return resolve(true);
            }
            setTimeout(waitForRefresh, 50);
          }
        )();
      })
    } else {
      this._refreshing = true;
      // Get current authentication data and refresh the token with new data
      //this.api.post('oauth/token', {});
      return this.api.post('v1/oauth/token', {
          'refresh_token': refresh_token,
          'grant_type': 'refresh_token',
          'client_id': this.client_id,
          'client_secret': this.client_secret,
          'scope': ''
        }
      ).then(data => {
        // Save token data

        return this.storeTokenData(data).then(() => {
          this.isLoggedIn = true;
          return true;
        });

      }, error => {
        this.isLoggedIn = false;
        return false;
      });
    }
  }

  public isAuthenticated(): Promise<boolean> {
    return this.token.get().then(data => {

      if (data) {
        // There are tokens. Are they still valid?
        let expired = moment().isAfter(moment(data['expires']));

        if (expired) {

          // Lets try a refresh
          return this.refresh(data['refresh_token']).then(refresh => {
            this.isLoggedIn = refresh as boolean;
            return refresh as boolean;
          }, error => {
            this.isLoggedIn = false;
            return false;
          });
        } else {
          // Validate the access token if it still works with calling current user info.
          return this.users.self().then(user => {
            this.isLoggedIn = true;
            this.users.currentUser = user;
            return true;
          }, err => {
            this.isLoggedIn = false;
            return false
          });
        }
      }
      this.isLoggedIn = false;
      return false;
    }, err => {
      this.isLoggedIn = false;
      return false;
    });
  }

  public loggedIn() {
    return this.isLoggedIn;
  }


  private storeTokenData(data: any) {
    // Validation of data
    return new Promise((resolve, reject) => {
      if (data['access_token'] != null && data['refresh_token'] != null && data['token_type'] != null && data['expires_in'] != null && data['token_type'] == 'Bearer') {
        resolve(this.token.set(data));
      } else {
        reject('Ongeldige Token. Inloggen moet zijn verlopen.');
      }
    });
  }


}
